import { createSelector } from '@reduxjs/toolkit'
import { Site, SiteUser } from 'types'
import type { SitesManagerState } from 'store/sitesManager/reducer'

export const selectSiteById = createSelector(
  [
    (state: SitesManagerState) => state.sites.data,
    (_state: SitesManagerState, id: number) => id,
  ],
  (sites, id): Site | undefined =>
    sites ? sites.find(site => site.id === id) : undefined,
)

export const selectSiteUsersBySiteId = createSelector(
  [
    (state: SitesManagerState) => state.siteUsers.data,
    (_state: SitesManagerState, siteId: number) => siteId,
  ],
  (siteUsers, siteId): SiteUser[] | undefined =>
    siteUsers ? siteUsers[siteId] : undefined,
)

export const selectSites = createSelector(
  [(state: SitesManagerState) => state.sites.data],
  (sites): Site[] | null => sites,
)

export const selectSitesIsLoading = createSelector(
  [(state: SitesManagerState) => state.sites.isLoading],
  (isLoading): boolean => isLoading,
)

export const selectSiteUsersIsLoading = createSelector(
  [(state: SitesManagerState) => state.siteUsers.isLoading],
  (isLoading): boolean => isLoading,
)

export const selectSiteSearchCriteria = createSelector(
  [(state: SitesManagerState) => state.sites.criteria],
  criteria => criteria,
)

export const selectBulkAddUsersResponse = createSelector(
  [(state: SitesManagerState) => state.siteUsers.addBulkUsersResponse],
  response => response,
)

export const selectIsBulkOperationCompleted = createSelector(
  [(state: SitesManagerState) => state.siteUsers.isBulkOperationCompleted],
  isCompleted => isCompleted,
)

export const selectMergeSiteState = createSelector(
  [(state: SitesManagerState) => state.mergeSiteState],
  mergeSiteState => mergeSiteState,
)
